<!-- Banner
    ============================================= -->
<div class="bg-light shadow-md pt-3 pb-3">
    <div class="container">
        <!-- <h1 class="text-6 font-weight-500 text-center">Super Offers</h1> -->
        <p class="text-left mb-3 text-4" *ngIf="availableOffers != null && availableOffers != ''"><b>Best Offers</b></p>
        <div class="owl-carousel owl-theme banner" id="owl-demo">
            <div class="item" *ngFor="let p of this.availableOffers">
                <a [href]="p.LinkURL">
                    <div class="card">
                        <img class="card-img-top" [src]="p.ImageURL" alt="banner">
                        <div class="card-body" *ngIf="p.PromoText!=''">
                            <h5 class="card-title text-center">{{p.PromoText}}</h5>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>
<!-- Banner end -->